module.exports = __webpack_public_path__ + "img/icon-sb-buy-now-desktop.6044a4f.svg";